import { render, staticRenderFns } from "./InvitedMembers.vue?vue&type=template&id=6436d478&scoped=true&"
import script from "./InvitedMembers.vue?vue&type=script&lang=js&"
export * from "./InvitedMembers.vue?vue&type=script&lang=js&"
import style0 from "./InvitedMembers.vue?vue&type=style&index=0&id=6436d478&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6436d478",
  null
  
)

export default component.exports